import React from 'react';

/**
 * Loader in sovraimpressione su tutta la pagina, mentre si leggono i dati.
 * Blocca i clic finche' la lettura non finisce: i filtri non cambiano a meta'.
 */
export default function BopLoaderOverlay({ visibile, testo = 'Lettura dei dati…' }: { visibile: boolean; testo?: string }) {
  if (!visibile) return null;
  return (
    <div className="bop-loader-overlay" role="status" aria-live="polite">
      <div className="bop-loader-overlay__box">
        <span className="bop-loader-overlay__spinner" aria-hidden="true" />
        <span className="bop-loader-overlay__testo">{testo}</span>
      </div>
    </div>
  );
}
